import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const cid = localStorage.getItem("active_company_id");
  if (cid) config.params = { ...(config.params || {}), company_id: cid };
  return config;
});

export function money(v, currency = "EUR") {
  const symbols = { EUR: "€", GBP: "£", USD: "$" };
  const n = Number(v || 0);
  return `${symbols[currency] || ""}${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDate(v) {
  if (!v) return "—";
  const dt = new Date(v);
  if (isNaN(dt)) return v;
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${dt.getFullYear()}`;
}
